export { default } from './useStateIfMounted';

export type * from './types';
